import { z } from 'zod';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { editGeneratableDocumentTemplate } from '@dealstack/frontend/shared/dataExchange/services/god.service.ts';

type FormValues = { name: string };

export const useTemplateDetailsTabController = (
	templateName: string,
	templateId: string,
	refetchTemplateData: () => Promise<void>
) => {
	const editDetailsRequest = useMutation({
		mutationFn: editGeneratableDocumentTemplate,
	});

	const [isEditMode, setIsEditMode] = useState(false);

	const editTemplateDetailsForm = useForm<FormValues>({
		mode: 'all',
		defaultValues: { name: '' },
		resolver: zodResolver(z.object({ name: z.string().nonempty() })),
	});

	const onSubmit = (formValues: FormValues) => {
		editDetailsRequest.mutate(
			{ id: templateId, name: formValues.name },
			{
				onSuccess: async () => {
					showToastV2({ title: 'Updated successfully' });
					await refetchTemplateData();
					setIsEditMode(false);
				},
			}
		);
	};

	useEffect(() => {
		editTemplateDetailsForm.reset({ name: templateName });
	}, [templateName]);

	return {
		editTemplateDetailsForm,
		onSubmit,
		isUpdating: editDetailsRequest.isPending,
		isEditMode,
		setIsEditMode,
	};
};
